// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nj-0";
export var leftAlign = "_nj-4";
export var listItem = "_nj-2";
export var listItemWrapper = "_nj-1";
export var operationText = "_nj-3";